import { Button } from "react-bootstrap";
import { BiMinus, BiPlus, BiTrash } from "react-icons/bi";
import "./Buttons.css"
import Notiflix from 'notiflix'
import moment from "moment";
import PostApiCall from "../Helpers/PostAPI";
import { useContext, useState } from "react";
import { newstore } from "../OnlineOrdering/Home/Pages/Store/newStore";
const ModifyQuantity = (props) => {

	const quantity = props.quantity;
	const itemid = props.itemid;
	const cartlineid = props.cartlineid;
	const { setLoginPopupWebsite } = useContext(newstore);
	const { setCartItemBeforeLogin } = useContext(newstore);
	const { setCategory4Data } = useContext(newstore);
	const { cart, setcart, cartItems, setCartItems, setCartData, setcartamount } =
		useContext(newstore);
	const GetCartdetails = () => {
		Notiflix.Loading.Dots("")
		var Order = localStorage.getItem("OrderData");
		var Orderdetails = JSON.parse(Order);
		var orderid = 0;
		// console.log(props)
		if (props.shippingAddress) {
			AddShippingChrg();
		}
		if (localStorage.getItem("OrderData") !== null) {
			orderid = Orderdetails[0].order_id;
		}
		if (localStorage.getItem("CustomerData") === null) {
			setLoginPopupWebsite(true);
		} else {
			var login = localStorage.getItem("CustomerData");
			var logindetails = JSON.parse(login);
			if (localStorage.getItem("OrderData") !== null) {
				PostApiCall.postRequest(
					{
						orderid:
							localStorage.getItem("OrderData") == null
								? null
								: Orderdetails[0].order_id,
						id:
							localStorage.getItem("CustomerData") == null
								? null
								: logindetails[0].fld_customerid,
					},
					"GetCartWebsite"
				)
					.then((res) => res.json())
					.then((res1) => {
						if (res1.data) {
							// setProductCart(res1.data);
							setcart(res1.data.reduce((a, v) => (a = a + v.fld_quantity), 0));
							setCartItems(res1.data);
							setCartData(res1.data);
							setcartamount(res1.data[0]?.fld_cart_amount);
							Notiflix.Loading.Remove()
						}
					});
			}
		}
	};
	const deletecart = (props) => {
		Notiflix.Loading.Circle("")
		var Order = localStorage.getItem("OrderData");
		var login = localStorage.getItem("CustomerData");
		var Orderdetails = JSON.parse(Order);
		var logindetails = JSON.parse(login);
		var orderid = 0;
		if (localStorage.getItem("OrderData") !== null) {
			orderid = Orderdetails[0].order_id;
		}
		PostApiCall.postRequest(
			{
				cartID: orderid,
				customerid:
					localStorage.getItem("CustomerData") == null
						? null
						: logindetails[0].fld_customerid,
				cartlineid: cartlineid,
				stateid: 0,
			},
			"DeleteCart"
		).then((result) =>
			result.json().then((obj3) => {
				if (result.status === 200 || result.status === 201) {
					Notiflix.Notify.Success("Product is successfully deleted.");
					GetCartdetails();
					// eslint-disable-next-line eqeqeq
					if (cartItems.length === 1) {
						localStorage.removeItem("OrderData");
					}
					GetCartdetails();
					Notiflix.Loading.Remove();
				} else {
					Notiflix.Loading.Remove();
					Notiflix.Notify.Failure(obj3.data);
				}
			})
		);
	};

	const addtocart = (qty) => {
		Notiflix.Loading.Circle("");
		var login = localStorage.getItem("CustomerData");
		var logindetails = JSON.parse(login);
		var Order = localStorage.getItem("OrderData");
		var Orderdetails = JSON.parse(Order);
		PostApiCall.postRequest(
			{
				orderdate: moment().format("lll"),
				itemdetails: `
                     [
                     {
                         "Item":${itemid},
                         "Quantity": ${qty},
                         "CartLineId":${cartlineid}
                     }
                     ]
                     `,
				status: "INCART",
				customerid:
					localStorage.getItem("CustomerData") == null
						? null
						: logindetails[0].fld_customerid,
				createdon: moment().format("lll"),
				updatedon: moment().format("lll"),
				orderid:
					localStorage.getItem("OrderData") == null
						? 0
						: Orderdetails[0].order_id,
				updatedby:
					localStorage.getItem("CustomerData") == null
						? null
						: logindetails[0].fld_userid,
			},
			"AddToCartWebsite"
		).then((result) =>
			result.json().then((obj) => {
				if (result.status === 200 || result.status === 201) {
					if (props == 1) {
						Notiflix.Notify.Success("Product added to Cart.");
					}
					if (localStorage.getItem("OrderData") == null) {
						localStorage.setItem("OrderData", JSON.stringify(obj.data));
					}
					GetCartdetails();
					Notiflix.Notify.Success("Product updated in Cart.");
					Notiflix.Loading.Remove();
				} else {
					Notiflix.Loading.Remove();
					Notiflix.Notify.Failure(obj.data);
				}
			})
		);
	};
	const AddShippingChrg = () => {
		const det = localStorage.getItem("CustomerData");
		const details = JSON.parse(det);
		var Order = localStorage.getItem("OrderData");
		var Orderdetails = JSON.parse(Order);
		PostApiCall.postRequest(
			{
				customerid: details[0].fld_customerid,
				orderid:
					localStorage.getItem("OrderData") == null
						? 0
						: Orderdetails[0].order_id,
				addressid: props?.shippingAddress,
			},
			"AddShippingChrg"
		).then((results) =>
			results.json().then((obj) => {
				if (results.status === 200 || results.status === 201) {
					// GetCartdetails();
				}
			})
		);
	};

	return (
		<div className="quantity-wrapper d-flex align-items-center flex-wrap">
			<button className="quatity-btn" size="sm" style={{
				borderTopLeftRadius: "6px",
				borderBottomLeftRadius: "6px"
			}}
				onClick={() => {
					addtocart(-1);
				}}
			>
				<BiMinus />
			</button>
			<input type="text" value={quantity} className="form-control quantity-input p-0" style={{
				borderLeft: 0,
				borderRight: 0,
				borderColor: "#fbf503",
				backgroundColor: "#fff"
			}} />
			<button
				className="quatity-btn" size="sm"
				onClick={() => {
					addtocart(1);
				}}
				style={{
					borderTopRightRadius: "6px",
					borderBottomRightRadius: "6px"
				}}
			>
				<BiPlus />
			</button>
			<button
				className="quatity-btn ms-1" size="sm"
				onClick={() => {
					deletecart();
				}}
			>
				<BiTrash />
			</button>
		</div>
	);
};

export default ModifyQuantity;
